import { LocaleManager } from '@bryntum/schedulerpro';
import { LocaleType } from '@crimsontide/core/client/interfaces';

import SvSE from '@bryntum/schedulerpro/locales/schedulerpro.locale.SvSE.js';
import En from '@bryntum/schedulerpro/locales/schedulerpro.locale.En.js';
import Gb from '../locales/british.locale';

function getLocaleConfig(locale: LocaleType) {
  switch(locale) {

    case LocaleType.SvSE: // Swedish
      return SvSE;

    case LocaleType.En: // English - United States
      return En;

    case LocaleType.Gb: // English - United Kingdom
       return Gb;
  }
}

/**
 * Apply the locale to the locale manager
 * @param locale
 */
export async function setLocale(locale: LocaleType): Promise<void> {
  if (!LocaleManager.locales[locale]) {
    const localeConfig = getLocaleConfig(locale);
    LocaleManager.registerLocale(locale, {
      desc: localeConfig.localeDesc,
      locale: localeConfig
    });
  }
  LocaleManager.applyLocale(locale);
}
